import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
var _excluded = ["id", "message", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Message } from '../Private';
var styles = {
  "root": "Notification-root_rkmjn",
  "message": "Notification-message_4Q-RZ"
};
function getMessageContent(message) {
  if (typeof message === 'string') {
    return /*#__PURE__*/React.createElement("p", null, message);
  }

  // Allow HTML.
  if (_typeof(message) === 'object' && '__html' in message) {
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: message
    });
  }

  // Allow single components | HTML tags.
  if ( /*#__PURE__*/React.isValidElement(message)) {
    // $FlowFixMe[incompatible-return] `&& '__html' in message` seems to break type refinement.
    return message;
  }

  // Allow Array of components | HTML tags.
  if (Array.isArray(message)) {
    // eslint-disable-next-line arrow-body-style
    return message.map(function (mess, idx) {
      if (_typeof(mess) === 'object' && '__html' in mess) {
        // eslint-disable-next-line react/no-danger, react/no-array-index-key
        return /*#__PURE__*/React.createElement("div", {
          key: "message-".concat(idx),
          dangerouslySetInnerHTML: mess
        });
      }

      // $FlowFixMe[incompatible-type]: Flow unable to refine
      return /*#__PURE__*/React.createElement("div", {
        key: "message-".concat(idx)
      }, mess); // eslint-disable-line react/no-array-index-key
    });
  }

  return null;
}
function Notification(_ref) {
  var id = _ref.id,
    message = _ref.message,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Message, _extends({
    withIcon: true,
    dismissible: true,
    buttonsAlign: "end",
    className: clsx(styles.root, className),
    classes: {
      content: styles.message
    }
  }, extraProps), getMessageContent(message));
}
export default Notification;